import { useBrandAccent } from './chunk-W3XOXPHM.js';
import { cn } from '@authe/ui-core';
import { jsx } from 'react/jsx-runtime';

function ProtocolIcon({ protocolId, icon: Icon, className }) {
  const accent = useBrandAccent(protocolId);
  return /* @__PURE__ */ jsx(Icon, { className: cn("size-4 shrink-0", accent.text, className), "aria-hidden": true });
}

export { ProtocolIcon };
//# sourceMappingURL=chunk-FZCG5QZY.js.map
//# sourceMappingURL=chunk-FZCG5QZY.js.map